import React, { useEffect, useState } from 'react';
import { Typography, Grid, Collapse, Spin } from 'antd';
import { JsonLd } from '../seo';

const { Title, Paragraph } = Typography;
const { useBreakpoint } = Grid;

const API_BASE = process.env.REACT_APP_API_BASE || '';
const BRAND = 'var(--brand-primary, #222957)';

// 預設常見問題（後台未填時顯示）— 星河耀眼原創文案
const DEFAULT_FAQ = [
  {
    q: '客製流程是怎麼進行的？',
    a: '在「客製手鏈」頁填入你的出生年月日等資訊後，我們會依五行與生命靈數為你配石排列，並提供設計建議。確認款式與尺寸、完成付款後即進入手作，通常 3～7 個工作天完成後出貨。',
  },
  {
    q: '手圍（尺寸）要怎麼量？',
    a: '用軟尺或一段細繩繞手腕最細處一圈，量出周長（公分），再依鬆緊喜好加 1～2 公分即為配戴周長。沒有軟尺的話，可用紙條繞一圈做記號後再拿尺量。下單時填入這個數字即可，我們會依款式做微調。',
  },
  {
    q: '配送方式與時間？',
    a: '提供超商取貨與宅配到府。商品完成後通常 1～3 個工作天送達；超商取貨到店後請於期限內領取。實際時效以物流狀況為準。',
  },
  {
    q: '可以退換貨嗎？',
    a: '客製商品因是為你量身製作，恕無法接受七日鑑賞退貨；但若收到時有瑕疵或與訂單不符，請於七日內聯繫我們並提供照片，我們會為你重製或協助處理。',
  },
  {
    q: '有哪些付款方式？',
    a: '支援信用卡線上刷卡，結帳時依畫面指示完成付款即可。付款成功後才會開始手作與安排出貨。',
  },
];

export default function Faq() {
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);

  useEffect(() => {
    let alive = true;
    fetch(`${API_BASE}/api/settings/shop`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (!alive) return;
        const faq = d && Array.isArray(d.faq_items)
          ? d.faq_items.filter((it) => it && (it.q || it.a))
          : [];
        setItems(faq.length ? faq : DEFAULT_FAQ);
      })
      .catch(() => { if (alive) setItems(DEFAULT_FAQ); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);

  const collapseItems = (items.length ? items : DEFAULT_FAQ).map((it, i) => ({
    key: String(i),
    label: <span style={{ fontWeight: 700, color: '#242C5E' }}>{it.q || '—'}</span>,
    children: (
      <Paragraph style={{ fontSize: isMobile ? 14 : 15, lineHeight: 1.9, color: '#2C3674', margin: 0, whiteSpace: 'pre-wrap' }}>
        {it.a || ''}
      </Paragraph>
    ),
  }));

  // FAQPage 結構化資料：讓 Google 有機會顯示 FAQ 展開卡片、AI 可直接引用問答。
  const faqSource = items.length ? items : DEFAULT_FAQ;
  const faqLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqSource
      .filter((it) => it && it.q && it.a)
      .map((it) => ({
        '@type': 'Question',
        name: it.q,
        acceptedAnswer: { '@type': 'Answer', text: it.a },
      })),
  };

  return (
    <div style={{ width: '100%', minHeight: '100%', background: isMobile ? '#fff' : '#F9FAFD' }}>
      {faqLd.mainEntity.length > 0 && <JsonLd id="faq" data={faqLd} />}
      <div style={{ maxWidth: 820, margin: '0 auto', padding: isMobile ? '24px 18px 40px' : '48px 32px 72px' }}>
        <Title level={1} style={{ fontSize: isMobile ? 24 : 30, color: BRAND, fontWeight: 800, letterSpacing: 1, marginBottom: isMobile ? 8 : 12 }}>
          購物須知・常見問題
        </Title>
        <Paragraph type="secondary" style={{ fontSize: isMobile ? 13 : 15, marginBottom: isMobile ? 20 : 28 }}>
          客製流程、尺寸測量、配送與退換貨等常見疑問，都整理在這裡。
        </Paragraph>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '60px 0' }}><Spin /></div>
        ) : (
          <Collapse
            accordion
            bordered={false}
            defaultActiveKey={['0']}
            items={collapseItems}
            style={{ background: '#F9FAFD', border: '1px solid #E5E7F5', borderRadius: 16, overflow: 'hidden' }}
          />
        )}
      </div>
    </div>
  );
}
